import { CustomFieldsConfiguration } from '../.././shared/custom-fields/custom-fields-models';

export class ApprovalQueue {
    CompanyId: number;
    WoJobId: number;
    WoNumber: string;
    WorkOrderId: number;
    CustomerName: string;
    CustomerId: number;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    ZipCode: string;
    ServiceEndTime: string;
    TechnicianName: string;
    TotalPrice: any;
    JobNo: string;
    TimeZoneId: number;
    TimeZoneDesc: string;
    SubmittedByUserId: number;
    SubmittedDate: Date;
    SubmittedSource: number;
    JobStatusId: number;
    Phone: string;
    ApproveStatus: number;
    ApprovedBy: string;
    ServiceAddressId: number;
    BillingAddressId: number;
    WoCategoryId: number;

    //Advance Search
    CompletedFrom: string;
    CompletedTo: string;
    FilterBy: number;
    TechId: number;
    VendorId: number;
    VendorName: string;
    CustAddressId: number;
    ApprovalStatusId: number;
    WoStatusId: number;
    InvoiceStatusId: number;
    CusTimeZoneCode: string;
    CusTimeZoneDesc: string;
    TechTimeZoneId: number;
    CustTimeZoneId: number;
    SearchText: string;
    CustomerType: string;
    ScheduleEndDateTimeCtz: string;
    ScheduleStartDateTimeCtz: string;
    WorkTask: string;
    ReasonCode: string;
    StatusReasonId: number;
    ScheduleDate: string;
    ClliCode: string;
    WoCategory: string;
    ZoneId: number;
    RegionId: number;
    Zone: string;
    Region: string;
}

export class ApprovalQueueList {
    ApprovalList: ApprovalQueue[] = [];
    TotalRecord: number;
}

export class Pagination {
    CompanyId: number;
    IsActive: number;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
}

export class AdvancedSearchDropdown {
    JobStatusId: number;
    JobStatus: string;
    zoneDetail: ZoneDetails[];
}

export class ConfigValues {
    ConfigDtlId: number;
    Description: string;
    ConfigMasterId?: number;
}

export class SJobAndBillingDetails {
    WorkOrderId: number;
    WoJobId: number;
    CompanyId: number;
    AddressLine1: string;
    AddressLine2: string;
    FirstName: string;
    LastName: string;
    Phone1: string;
    Phone2: string;
    Email: string;
    OtherAmount: any;
    CashReceived: any;
    PaymentModeId: number;
    CustomerName: string;
    Technician: string;
    ScheduleDate: Date;
    ScheduleStartDateTime: Date;
    ScheduleEndDateTime: Date;
    SLAStartTime: Date;
    SLAEndTime: Date;
    IsSLAMet: boolean;
    Days: number;
    Hours: number;
    Minutes: number;
    ActualWorkedHours: number;
    ActualWorkedMinutes: number;
    JobStatusId: number;
    StatusReasonId: number;
    StatusReason: string;
    StartTime: Date;
    ArrivalTime: Date;
    ServiceStartTime: Date;
    Region: string;
    TimeZoneId: number;
    TimeZoneDesc: string;
    TimeZoneCode: string;
    AddressName: string;
    UnitNo: string;
    CityName: string;
    ZipCode: string;
    ServiceEndTime: Date;
    SubmittedByUserId: number;
    SubmittedDate: Date;
    SubmittedSource: number;
    PaymentMode: string;
    AmountCollected: string;
    JobPriceTotal: string;
    PrintNotes: boolean;
    CusTimeZoneCode: string;
    CusTimeZoneDesc: string;
    IsPmOrder?: boolean;
    StateShortName?: string;
    AcctualAddress: string;
    WoAppointmentId: number;
    TechId: number;
    TechPhone: string;
    TechPhone2: string;
    VendorName: string;
    VendorPhone1: string;
    CustContactId: number;
    ActualContactName: string;
    ScheduleSlot: string;
    WoApprovalValidation:number;
    QuoteNumber: string;
    RevisonNo:number;
    QoJobPriceTotal:any;
    CustomerId:number;
    ClliCode:string;
    Zone:string;
    CustomerType:string;
    CustomerTypeNo:string;
    IsNetwork?:number;
    ActualWorkedDays:number;
    BillingCustomerName:string;
    ResolutionSLAStarttime:Date;
    ResolutionSLAEndTime:Date;
    ResolutionIsSLAMet:boolean;
    ResponseSLAStarttime:Date;
    ResponseSLAEndTime:Date;
    ResponseIsSLAMet:boolean;
}

export class NotesModel {
    NotesID: number;
    NotesMasterId: number;
    PrimaryKeyId: number;
    CompanyId: number;
    Note: string;
    CreatedBy?: number;
    CreatedDate: Date;
    LastChangedBy?: number;
    LastUpdate?: Date;
    UpdateBy?: number;
    UpdateDate?: Date;
    CreateAndUpdate: number;
    CreateAndUpdateDate: string;
    tempId: number;
    CreatedByName: string;
    LastChangedByName: string;
    Jobno: number;
    jobval: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    VisibleToVendor?:number;
}

export class ServiceNotesAndTechNotes {
    DisplayName: string;
    GetWojobServiceNotesDetails: NotesModel[];
    GetWojobTechnicialRemark: NotesModel[];
    approverRemark: NotesModel[];
    invoiceNotes: NotesModel[];
    AdminNotesDetails: NotesModel[];
}

export class ClosePopup {
    Responce: boolean;
    AdditionalInfo?: any;
}

/**Pricing */
export class Pricing {
    priceList: PricingModel[];
    JobTotal: number;
}

export class PricingModel {
    WoJobPriceId: number;
    WorkTask: string;
    Description: string;
    Qty: any;
    UnitPrice: any;
    Discount: any;
    DiscountTypeId: number;
    PriceTypeId: number;
    WorkTaskNumber: string;
    WoJobDetailsId: number;
    PriceType: string;
    TaskNo: number;
    TotalAmount: any;
    NetTotal: any;
    JobTotal: any;
    WorkTypeId: number;
    WorkTaskId: number;
    WoJobId: number;
    Tax: string;
    Percentage: number;
    PercentageAmount: number;
    TaxIdGroupId?: number;
    ApprovalStatusId: number;
    ApprovalStatus: string;
    //BOQ --
    IsBOQRequest: number;
    VendorId: number;
    ApprovedQty: number;
    // -- BOQ
    PricingUnit:string;
    PricingUnitId:number;
    Warranty: number;
    DaysPerTask: number;
    HoursPerTask : number;
    MinutesPerTask : number;
    FormatQty: number;
    WorkGroupId: number;
    MarkupPercentage: number;
    VCost: number;
    Adjustment: number;
}

export class PricingModelTable {
    WoJobPriceId: number;
    WorkTask: string;
    Description: string;
    Qty: any;
    UnitPrice: any;
    Discount: any;
    DiscountTypeId: number;
    PriceTypeId: number;
    WorkTaskNumber: string;
    WoJobDetailsId: number;
    PriceType: string;
    TaskNo: number;

    TotalAmount: any;
    NetTotal: any;
    JobTotal: any;
    WorkTypeId: number;
    WorkTaskId: number;
    CompanyId?: number;

    NetTotalFormat?: any;
    UnitPriceFormat?: any;
    TotalAmountFormat?: any;
    DiscountFormat?: any;
    QtyFormat?: any;
    WoJobId: number;
    netTotal?: any;

    TotalWorkOrderPrice?: number;
    CreatedBy?: number;
    Tax: string;
    Percentage: number;
    TaxFormat?: any;
    PercentageAmount: number;
    ApprovalStatusId: number;
    ApprovalStatus: string;
    //BOQ --
    IsBOQRequest: number;
    VendorId: number;
    ApprovedQty: number;
    // -- BOQ
    PricingUnit:string;
    PricingUnitId:number;
    Warranty: number;
    DaysPerTask: number;
    HoursPerTask : number;
    MinutesPerTask : number;
    FormatQty: number;
    WorkGroupId: number;
    MarkupPercentage: number;
    VCost: number;
    Adjustment: number;
}

export class PricingFormModel {
    WoJobPriceId: number;
    CompanyId: number;
    WoJobId: number;
    WoJobDetailsId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    PriceTypeId: number;
    Qty: number;
    UnitPrice: any;
    Description: string;
    DiscountTypeId: number;
    Discount: any;
    TaskNo: number;
    CreatedBy: number;
    LastChangedBy: number;
    isApprovalQueue: boolean;
    MarkupPercentage:number;
}
export class PartPricing {
    TaskNo: number;
    PartRequestId: number;
    description: string;
    qty: any;
    unitPrice: any;
    NetTotal: any;
    JobTotal: any;
    discount: any;
    discounttype: number;
    total: any;
    priceTypeId: number;
    priceIndx: number;
    wopartpriceid: number;
    DiscountTypeId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    Percentage: number;
    Tax: string;
    TaxFormat?: any;
    NetTotalFormat?: any;
    WoJobId: number;
    CompanyId: number;
    CreatedBy: number;
    LastChangedBy: number;
}

export class WorkRequestSaveModel {
    WoJobDetailsId: number;
    CompanyId: number;
    WoJobId: number;
    WorkTypeId: number;
    WorkTaskId: number;
    Days?: number;
    Hours?: number;
    Minutes?: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WoCategoryId: number;
    WoCategory: string;
    WorkType: string;
    WorkTask: string;
    WorkTaskNumber: string;
    CustomerPrice: any;
    TechCost: any;
    IsAutoSchedule: boolean;
    HourAndMinutes: any;
    TaskNo: number;
    TechId?: number;
    VendorId?: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    WorkOrderId: number;
    CustomerId: number;
    Qty: number;
    PricingUnitId: number;
    WorkGroupId: number;
}
export class WorkRequestCFModel {
    WorkRequestSaveModel: WorkRequestSaveModel;
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class RouteParams {
    WoJobId: number;
    WorkOrderId: number;
    ServiceAddressId: number;
    BillingAddressId: number;
    WoCategoryId: number;
    CustomerId: number;
    TimeZoneId: number;
    TechnicianName: string;
    WoNumber: string;
    TimeZoneDesc: string;
    VendorName: string;
    CustAddressId: number;
    ApprovalStatusId: number;
    WoStatusId: number;
    InvoiceStatusId: number;
    CustTimeZoneDesc: string;
    TechId: number;
    VendorId: number;
    TechTimeZoneId: number;
}

// export class JobDetails {
//     WoJobDetailsId: number;
//     CompanyId: number;
//     WoJobId: number;
//     WorkTypeId: number;
//     WorkTaskId: number;
//     Days: number;
//     Hours: number;
//     Minutes: number;
//     CreatedBy: number;
//     CreatedDate: Date;
//     LastChangedBy: number;
//     LastUpdate: Date;
//     WoCategoryId: number;
//     WoCategory: string;
//     WorkType: string;
//     WorkTask: string;
//     WorkTaskNumber: string;
//     CustomerPrice: any;
//     TechCost: any;
//     IsAutoSchedule: boolean;
//     HourAndMinutes: any;
//     TaskNo: number;
// }

export class WorkTypeDd {
    WorkTypeId: number;
    WoCategoryId: number;
    WorkType: string;
}

export class WorkRequestDd {
    WoCategoryId: number;
    WoCategory: string;
    WorkTypeId: number;
    WorkType: string;
    WorkTaskId: number;
    WorkTask: string;
    CustomerPrice: number;
    DaysPerTask: number;
    HoursPerTask: number;
    MinutesPerTask: number;
    IsAutoSchedule: number;
    IsActive: number;
    TechCost: number;
    AddDriveTime: number;
    WorkGroupId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    PricingUnitId: number;
}

export class WoJobvendorCost {
    WoJobvendorCostId: number;
    CompanyId: number;
    WoJobId: number;
    WoJobDetailsId: number;
    Cost: number;
    VendorCost: number;
    Adjustment: string;
    AdjustmentReason: string;
    TechId: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    WorkTypeId: number;
    WorkType: string;
    VendoTechnicianCost: number;
    WorkTaskId: number;
    WorkTask: string;
    PricingUnit: string;
    PricingUnitId: number;
    Qty: number;
    Days: number;
    Hours: number;
    Minutes: number;
    FormatQty: number;
    PriceTypeId: number;
    WoJobPriceId: number;
    TechCost: string;
    VMTechCost: string;
    Description: string;
}

export class JobvendorCost {
    woJobvendorCost: WoJobvendorCost[] = [];
    TotalCost: number;
}

export class VendorPaymentHistory {
    VendorCostAdjustHistoryId: number;
    CompanyId: number;
    TechId: number;
    WoJobId: number;
    WoJobDetailsId: number;
    Cost: number;
    VendorCost: number;
    Adjustment: any;
    AdjustmentReason: string;
    CreatedBy: number;
    CreatedDate: any;
    WorkTypeId: number;
    WorkType: string;
    WorkTaskId: number;
    WorkTask: string;
    DisplayName: string;
}

export class PaymentDetail {
    WoJobPaymentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    PaymentModeId: number;
    CashReceived: any;
    OtherAmount: any;
    ChequeNo: string;
    ChequeDate: string;
    BankName: string;
    ReceiptNo: string;
    CreatedBy: number;
    LastChangedBy: number;
    TimeZoneId?: number;
}

export class EquipmentListModel {
    BrandId: number;
    Brand: string;
    ModelId: number;
    Model: string;
    SerialNo: string;
    TagNo: string;
    Description?: string;
    WoEquipmentId: number;
    CustomerEquipmentId: number;
    WoJobEquipmentId: number;
    CompanyId: number;
    WoJobId: number;
    WorkOrderId: number;
    WoAddressId: number;
    ContractStartDate: string;
    ContractEndDate: string;
    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
    InstallationDate: string;
    ManufactDate: string;
    WarrantyDate: string;
    InstallDate: string;
    
    ContractSDate: string;
    ContractEDate: string;
    IsContractExpiredColor: string;
    PriorityId?: number;
    Duration?: number;
    Durationstr: any;
}

export class EquipmentEntity {
    BrandId: number;
    Brand: string;
    ModelId: number;
    Model: string;
    SerialNo: string;
    TagNo: string;
    Description?: string;
    WoEquipmentId: number;
    CustomerEquipmentId: number;
    ContractStartDate: string;
    ContractEndDate: string;
    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
  

    IsContractExpiredColor?: string;
    CompanyId: number;
    WoJobId: number;
    WorkOrderId: number;
    WoAddressId: number;
    IsActive: number;
   // InstallationDate?: Date;
    InstallationDate?: string;
    CreatedBy?: number;
    CreatedDate?: Date;
    LastChangedBy: number;
    LastUpdate?: Date;
    CustomerId: number;
    //Add Existing
    BrandName?: string;
    WoJobNumber?: number[];
    WoJobEquipmentId?: number;
    CustAddressId?: number;
    PriorityId?: number;
    Duration?: number;
    Durationstr: string;
    PriorityColor: string
    ContractSDate?: string;
    ContractEDate?: string;
    CreatedSourceId?: number;
    UpdatedSourceId?: number;
    Status?: string;
    isactive?: number;

}
export class EquipmentCFModel {
    WoEquipmentEntity: EquipmentEntity[];
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class ExistingEquipmentModel {
    BrandId: number;
    BrandName: string;
    ModelId: number;
    Model: string;
    SerialNo: string;
    TagNo: string;
    Description: string;
    CustomerEquipmentId: number;
    AddressName: string;
    IsActive: number;
    CustomerId: number;
}

export class AttachmentModel {
    WoAttachmentId: number;
    CompanyId: number;
    WorkOrderId: number;
    WoJobId: number;
    AttachmentCategoryId: number;
    AttachementTypeId: number;
    Description: string;
    CapturedDate: string;
    CapturedTime?: Date;
    FileName: string;
    FilePath: string;
    CreatedBy: number;
    LastChangedBy: number;
    Attachment: string;
    AttachementType?: string;
    AttachementCategoryType?: string;
    RefCapturedDate?: string;
    TimeZoneDesc?: string;
    TimeZoneId?: number;
    DocThumbImage?: string;
    Latitude: number;
    Longitude: number;
    GPSCode?: number;
    CreatedByName: string;
    LastChangedByName: string;
    CreatedDate: string;
    LastUpdate: string;
    Type?: string;

}

export class ChecklistModel {
    WoJobChklistId: number;
    WoJobId: number;
    ChklistMastId: number;
    CompanyId: number;
    ChklistName: string;
    Description: string;
    IsActive: number;
    CreatedBy: number;
    LastChangedBy: number;
    WorkOrderId: number;
    CustomerId: number;
}
export class ChecklistDropdown {
    ChklistMastId: number;
    ChklistName: string;
    Description: string;
    IsActive: number;
}

export class DynamicCheckListDetails {
    WoJobChecklistDetailId: number;
    WoJobId: number;
    ChklistActiveDtl: number;
    CompanyId: number;
    ChklistDtlId: number;
    ChklistMastId: number;
    QuestionId: number;
    Question: string;
    FieldTypeId: number;
    IsOptional: boolean;
    MaxLength: number;
    FieldUnits: string;
    OrderNo: number;
    ChklistDdMastId: number;
    ChklistStatusId: number;
    IsActive: boolean;
    CreatedBy: number;
    Description: string;
    ValueList: string;
    WoJobChklistId: number;

    //dropdownvalues
    dropdownvalues: DropDownValues[];

    formconName: string;
    ControlType: string;
    TextValue: string;
    BooleanValue: number;
    WoChklistDdId: number;
}

export class DropDownValues {
    ChklistDdDtlId: number;
    ValueList: string;
}

export class DynamicSaveModel {
    WoJobChecklistDetailId?: number;
    CompanyId?: number;
    WoJobId?: number;
    WoJobChklistId?: number;
    ChklistDtlId?: number;
    FieldTypeId?: number;
    TextValue?: string;
    BooleanValue: number;
    WoChklistDdId?: number;
    CreatedBy?: number;
    CreatedDate?: Date;
    ChklistMastId?: number;
    LastUpdate?: Date;
    LastChangedBy?: number;
    IsOptional: boolean;

    formconName: string;
    ControlType: string;
    Hidden: string;
    ChklistActiveDtl: number;
}

export class DynamicModel {
    Questions: DynamicCheckListDetails[] = [];
    Answers: DynamicSaveModel[] = [];
}

export class ControlsName {
    key: number;
    value: string;
}

export class ATextBox {
    Id: number;
    Value: string;
}
export class NTextBoxData {
    Id: number;
    Value: string;
}
export class DropDownData {
    Id: number;
    Value: string;
}
export class CheckBoxData {
    Id: number;
    Value: string;
}
export class DynamicData {
    Id: number;
    Value: string;
}

export class ApprovalJobModel {
    WorkOrderId: number;
    WoJobId: number;
    CreatedBy: number;
    CompanyId: number;
    TimeZoneId: number;
    CustomerId: number;
    ApprovalBy: number;
    ApprovalRevertBy: number;
    Remarks?: string;
    PrintNotes?: boolean;
    ApproverName?:string;
    CRemarks?:string;
    ShowVendor?:number;
}


export class wojoblist {
    WoJobId: number[];

}
export class RevertApprovalHistory {
    CreatedDate: Date;
    DisplayName: string;
    Remarks: string;
}

export class Download {
    byteData: any[];
    fileName: string;
}

export class BrandList {
    BrandId: number;
    Brand: string;

}
export class ModelList {
    ModelId: number;
    Model: string;

}

export class CustomerTimeZone {
    CustomerDateTime: string;
    CurrentDateTime: string;
}

// As discussed with vijay TN Added by Anvardeen Batcha 
export class JobStatusReason {
    StatusReasons: StatusReasons[];
    TotalRecord: number;
}

export class StatusReasons {
    StatusReasonId: number;
    StatusReason: string;
    JobStatusId: number;
    JobStatus: string;
    RecordType: number;
}
// As discussed with vijay TN Added by Anvardeen Batcha 

export class TechnicianJobStatusUpdate {
    WorkOrderId: number;
    jobid: number;
    WoAppointmentId: number;
    jobstatus: number;
    unresolvedreasonid: number;
    companyid: number;
    StartDate: string;
    StartTime: string;
    ArrivalTime: string;
    ArrivalDate: string;
    ServiceStartTime: string;
    ServiceEndTime: string;
    LastChangedBy: number;
    lastupdate: Date;
    ismobile: number;
    ServiceEndDate: string;

    CompleteResonId: number;
    UnResolveReasondId: number;
    ScheduleStartDate: string;
    LoginId: number;
    TechTimeZoneid: number;
    ActualWorkedHours: number;
    ActualWorkedMinutes: number;

    TechnicianId: number;
    PreviousJobStatus: number;
    UpdatedSourceId: number;
    StatusReasonId: number[];
}

export class CusstomerAddress {
    CustomerAddressId: number;
    CompanyId: number;
    AddressName: string;
    CustomerId: number;
    AddressTypeId: number;
    IsPrimary: number;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    StateId?: number;
    StateName: string;
    ZipCode: string;
    CountryId?: number;
    CountryName: string;
    StateShortName: string;
    UserLat?: number;
    UserLon?: number;
    UnitNo: string;
    ZipLon?: number;
    MapLat?: number;
    ZipLat?: number;
    MapLon?: number;
    CreatedBy: number;
    IsActive?: number;
    ChangePrimary?: number;
    CopyAddress: number;
    CopyBillingAccount?: number;
    RegionId?: number;
    BillingAccountId: number;
    CustomerName: string;
    LastChangedBy: number;
    WorkOrderId: number;
    WoJobId: number;
    BillingCustomerId: number;
}

export class CustomerContact {
    CustomerContactId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerAddressId: number;
    AddressTypeId: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    IsPrimary: number;
    TitleId?: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    ContactTypeId: number;
    Fax: string;
    IsActive: number;
    ContactType: string;
    TitleName: string;
    CreatedBy: number;
    CreatedDate?: Date;
    LastChangedBy?: number;
    LastUpdate?: Date;
    WorkOrderId: number;
    WoJobId: number;
}

export class JobCompStatus {
    JobStatusCompId: number;
    JobStatusId: number;
    JobStatus: string;
    StatusReason: string;
    Description: string;
    IsActive: number;
    StatusReasonId: number;
}

//TAX -- Added by Anvardeen Batcha
export class TaxGroup {
    TaxId: number;
    TaxName: string;
    TaxPercent: number;
    TaxValue: string;
    IsActive: boolean;
}
export class jobNumber {
    wojobid: number;
}
export class PartRequest {
    WoJobId: number;
    PartNo: string;
    PartRequestNo: string;
    Description: string;
    Warehouse: string;
    RequestedQty: number;
    IsActive: number;
    IsSerialized: number;
    RequestStatusId: number;
    PartId: number;
    WarehouseId: number;
    SerialNo: SerialNumber[];

    UomId: number;
    UnitPrice: string;
    Uom: string;

    PartNotes: string;
    IsOEM: number;
    IsCoreReturn: number;
    OEMName: string;
    OrderNo: string;
    ShipVia: string;
    ShippingDate: string;
    TrackingNo: string;
    ETADate: string;
    ETATime: string;
    RMANo: string;
    RMATrackingNo: string;
    RMAShippingDate: string;
    RMANotes: string;
    WoPartPriceId: number;
    TaxTypeId: number;
    TaxIdGroupId: number;
    CoreReturnStatusID: number;
    CoreReturnNotes: string;
    PartReqStatusId: number;
    PartRequestId: number;
    Status: boolean;
    DropPoint: string;
    OEMPartReqTypeId: number;
    ReceivedOn: string;
    Attachement: string;
}
export class SerialNumber {
    SerialNo: string;
}

export class SystemSettings {
    SettingId: number;
    settingValue: string;
}

export class Reject {
    CompanyId: number;
    WoJobId: number[];
    Remarks: string;
    LoginId: number;
    CreatedSourceId: number;
    CreatedBy: number;
    VendorApproval?:VendorApproval[]=[];
    VendorApprovalStatusId?:number;
    ViewId?:number;
    ShowVendor?:number;
    ApproverName?:string;
    workGroupId?:number;
    
}

export class PartDetail
{
    CompanyId: number;
    VendorApproval?:VendorApproval[]=[];
}
export class CloseVendorPopup {
    Responce: boolean;
    ApproveValue?: Reject;
    viewid?:number;
}

export class VendorApproval {
    WoJobId: number;
    WoAppointMentId: number;
    WorkOrderId?:number;
}

export class Region {
    Region: string;
    RegionId: number;
}
export class ZoneDetails {
    ZoneId: number;
    Zone: string;
}
export class RefStatusReasonEntity {
    WoAppointmentStatusReasonId: number;
    StatusReasonId: number;
    StatusReason: string;
}

export class paymentApproval {
    pricingAmt: any;
    CollectedAmt: any;
    PaymentId: any;
}
export class WOCategory {
    WoCategoryId: number;
    CompanyId: number;
    WoCategory: string;
    Description: string;
    IsDefault: number;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate: string;
}
export class PunchPointApprovalQueue {
    CompanyId: number;
    WoJobId: number;
    WoNumber: string;
    WorkOrderId: number;
    CustomerName: string;
    CustomerId: number;
    JobNo: string;
    JobStatusId: number;

    //Advance Search
    ApprovalStatusId: number;
    WoStatusId: number;
    SearchText: string;
    CustomerType: string;
    WoCategory: string;
    WoCategoryId: number;
    ZoneId: number;
    RegionId: number;
    Zone: string;
    Region: string;
    SiteId: number;
    SiteName: string;
    PunchPointStatusId: number;
    Status: string;
    MasterJobStatus: number;
    CreatedBy: string;
    WorkTypeId: number;
    WorkType: string;
    SourceJobId: number;
    SourceJob: string;
    SourceTTId: number;
    SourceTT: string;
    WorkTaskId: number;
    WorkTask: string;
    ApproveRejectBy?: string;
    ApproveRejectDate: Date;
    GenaratedWonumber?: string;
    GenaratedWoId: number;
    Attachment: string;
    WoPunchPointsAttachment: number;
    AttachmentCategoryId: number;
    WOPunchPointsId: number;
    IsActive: number;
    PunchPointStatus: string;
    Attachmentcounts: number;
    StatusDate: string;
    ApproveRejectId: number;
    Comments: string;
    WorkGroupId: number;
    Remarks: string;
}
export class PunchPointApproveRejectDtl {
    ApproveRejectDtlId: number;
    CompanyId: number;
    ApproveRejectId: number;
    SourceJobId: number;
    SourceWorkOrderId: number;
    IsProcessed: number;
    ProcessStatusId: number;
    CreatedBy: number;
    WOPunchPointsId: number;
}

export class PunchDetails {
    WOPunchPointsId : number[];
    CompanyId : number;
    WorkOrderId : number;
    SourceJobId : number;
    CreatedSourceId : number;
    CreatedBy : number;
    Remarks: String;
}
export class PunchPointApproveReject {
    ApproveRejectId : number;
    CompanyId : number;
    StatusId : number;
    IsProcessed : number;
    ProcessStatusId: number;
    CreatedBy: number;
    Remarks: string;
}
export class PunchPointApproveRejectList{
    punchApprove: PunchPointApproveReject;
    punchApproveDetails:PunchPointApproveRejectDtl[];
}
export class PunchPointStatus {
    PunchPointStatusId: number;
    IsActive: number;
    Status: String;
}
export class PunchPointApprovalQueueList {
    PunchPointApprovalList: PunchPointApprovalQueue[] = [];
    TotalRecord: number;
}
